import Vue from 'vue';
import Config from '../configuration';

export default {
    namespaced: true,
    mutations: {

    },
    getters: {

    },
    actions: {
        createRepayment (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.post(Config.GetUrl(Config.kritaApi) + 'repayments/' , {selectedFactorings: payload.selectedFactorings, ClaimantKennitala: self.state.userInfo.SelectedClaimant.Kennitala, IsLegalRepayment: payload.IsLegalRepayment}, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getRepaymentsReport (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'repayments/' , {ClaimantId: self.state.userInfo.SelectedClaimant.ClaimantId, Current :payload.page, RowCount: payload.rowsPerPage, Sort: payload.sort, Selection: payload.selection, Type: payload.type, Search: payload.search }, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getRepaymentsDetailHistory (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'repayments/' + payload.id +'/?current=' + payload.page + '&rowCount=' + payload.rowsPerPage + '&orderBy=' + payload.sortBy + '&order=' + payload.sort, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getRepaymentsFactoringsFromHistory (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'repayments/' + payload.id + '/GetFactoringsHistroyForRepayment/?current=' + payload.page + '&rowCount=' + payload.rowsPerPage + '&orderBy=' + payload.sortBy + '&order=' + payload.sort + '&search=' + payload.search, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getRepaymentsFactorings (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'repayments/' + payload.id + '/GetFactoringsForRepayment/?current=' + payload.page + '&rowCount=' + payload.rowsPerPage + '&orderBy=' + payload.sortBy + '&order=' + payload.sort + '&search=' + payload.search, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getRepaymentDetail (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'repayments/' + payload.id , {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
    }
}
